// src/pages/Tools/components/ToolStepCard.tsx
// Replaces: .step-item-tool, .step-number-tool,
//           h3 and p inside step-item-tool (shared with feature-card-tool)

import React from 'react';
import { cn } from '../../../lib/utils';

interface ToolStepCardProps {
    /** Step number shown in the 56px circle */
    number: number | string;
    /** Card heading */
    title: string;
    /** Card body text */
    description?: string;
    children?: React.ReactNode;
    className?: string;
}

/*
 * .step-item-tool:
 *   padding: 24px; text-align: center;
 *
 * .step-number-tool:
 *   display: inline-flex; align-items: center; justify-content: center;
 *   width: 56px; height: 56px; background: #1a73e8; color: white;
 *   font-size: 1.5rem; font-weight: 600; border-radius: 50%; margin-bottom: 20px;
 *
 * h3 inside: font-size: 1.125rem; font-weight: 500; color: #202124; margin: 0 0 12px;
 * p inside:  font-size: 0.875rem; color: #5f6368; margin: 0; line-height: 1.6;
 */
const ToolStepCard: React.FC<ToolStepCardProps> = ({
    number,
    title,
    description,
    children,
    className,
}) => (
    <div className={cn('p-[24px] text-center', className)}>
        <div className="inline-flex items-center justify-center w-[56px] h-[56px] bg-[#1a73e8] text-white text-[1.5rem] font-semibold rounded-full mb-[20px]">
            {number}
        </div>
        <h3 className="text-[1.125rem] font-medium text-[#202124] m-0 mb-[12px]">
            {title}
        </h3>
        {description && (
            <p className="text-[0.875rem] text-[#5f6368] m-0 leading-[1.6]">
                {description}
            </p>
        )}
        {children}
    </div>
);

export default ToolStepCard;
